import Vue from "vue";
import Router from "vue-router";

import Home from "./components/ExHome.vue";
import Login from "./components/LoginComponent.vue";
import Backend from "./components/BackendComponent.vue";
import Demo from "./components/DemoComponent.vue";
import MobileHome from "./components/mobile/MobileHome.vue";

Vue.use(Router);

const isMobile = () => {
  // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  return window.innerWidth < 786;
};

export const routes = [
  {
    path: "/",
    component: Login,
    name: "login",
  },
  {
    // Home Assistant 網頁面版登入畫面
    path: "/ha",
    component: Login,
    name: "ha-login",
  },
  {
    // Home Assistant 網頁面版電力監控頁面
    path: "/ha-page",
    component: Demo,
    name: "ha-page",
    meta: { requiresAuth: true },
  },
  {
    path: "/home/:user?",
    component: Home,
    name: "home",
    meta: {
      requiresAuth: true,
    },
  },
  {
    // 手機版
    path: "/m/home",
    component: MobileHome,
    name: "mobile_home",
    meta: {
      requiresAuth: true,
    },
  },
  {
    // 電力監控後台
    path: "/admin",
    component: Backend,
    name: "backend",
    meta: {
      requiresAuth: true,
    },
  }
];

const router = new Router({ mode: "history", routes });

function isUserLoggedIn() {
  const isUserLoggedIn = localStorage.getItem('token');
  if (!!isUserLoggedIn) {
    window.axios.defaults.headers["Authorization"] = isUserLoggedIn;
    return true;
  } else {
    return false;
  }
}

/**
 * check user's permission
 *
 * @returns
 */
async function notBxAdmin() {
  const response = await axios.post(base_url + '/api/user/validate');

  return response.data;
}

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (isUserLoggedIn()) {
      if (to.name === "backend") {
        notBxAdmin()
          .then(res => { res ? next("/") : next() })
          .catch(err => { console.log(err) });
      }
      next()
    } else { next("/") }
  } else { next(); }

  if (to.path === "/" && isUserLoggedIn()) {
    next('/home');
  }

  if (isMobile()) {
    if (to.name === "home") {
      next('/m/home');
    }
  } else if (to.name === "mobile_home") {
    next('/home');
  } else {
    next();
  }
});

export default router;
